"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DawnbreakerAbilityHandler = exports.DawnbreakerActorAbilityFactory = exports.DawnbreakerAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DawnbreakerAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Dawnbreaker;
        this.__typeName = "Dawnbreaker";
    }
}
exports.DawnbreakerAbilityArgs = DawnbreakerAbilityArgs;
let DawnbreakerActorAbilityFactory = class DawnbreakerActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Dawnbreaker", "AllEnemies", 1);
    }
};
DawnbreakerActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Dawnbreaker")
], DawnbreakerActorAbilityFactory);
exports.DawnbreakerActorAbilityFactory = DawnbreakerActorAbilityFactory;
let DawnbreakerAbilityHandler = class DawnbreakerAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            sequence,
            attackType: "ranged",
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            targets: enemies.map(enemyId => ({
                targetId: enemyId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                ],
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "LightningStrike")),
        });
    }
};
DawnbreakerAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Dawnbreaker)
], DawnbreakerAbilityHandler);
exports.DawnbreakerAbilityHandler = DawnbreakerAbilityHandler;
